module.exports = __webpack_public_path__ + "img/symbol_4.67f17205.png";